// extracted by mini-css-extract-plugin
export var latestAnnouncements = "BlogPosts-module--latestAnnouncements--UiaqL";
export var inner = "BlogPosts-module--inner--F6SyC";
export var noBlogPosts = "BlogPosts-module--noBlogPosts--pBoa0";
export var posts = "BlogPosts-module--posts--ok4V6";
export var singleBlog = "BlogPosts-module--singleBlog--rd3pH";